const INVALID_VALUES = new Set(['null', 'undefined', '']);

export function assertValidParam(value: string, paramName: string): string {
  const trimmed = value?.trim();
  if (!trimmed || INVALID_VALUES.has(trimmed)) {
    throw new Error(`Missing required parameter: ${paramName}`);
  }
  return trimmed;
}

export function sanitizeQueryParam(raw: string | null): string | null {
  if (!raw || INVALID_VALUES.has(raw)) return null;
  return raw;
}
